"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../Button/Button"));

require("./Cards.scss");

require("./CardsDark.scss");

var _reactstrap = require("reactstrap");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Cards = function Cards(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: props.id,
    className: 'gcl-cards'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-cards-wraper ".concat(props.check ? 'checked' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-head-cards"
  }, props.title, props.iconActive && /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-head-cards-icon",
    id: 'gcl-head-cards-icon-' + props.id
  }, /*#__PURE__*/_react["default"].createElement("i", {
    "class": 'gcl-icon ' + props.icon
  }), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    target: 'gcl-head-cards-icon-' + props.id,
    placement: "top",
    autohide: false,
    trigger: 'hover'
  }, props.iconLabel))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-cards-body gcl-cards-body-color ".concat(props.check ? 'checked' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-title-cards"
  }, props.content), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-content-date-cards"
  }, props.date)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-footer-cards"
  }, props.btnLeft, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "tertiary"
  }, props.btnRigth))));
};

Cards.defaultProps = {
  id: '1',
  tittle: '',
  content: '',
  btnLeft: '',
  btnRigth: '',
  date: '',
  check: false,
  iconActive: false,
  icon: 'home',
  iconLabel: ''
};
Cards.propTypes = {
  id: _propTypes["default"].string,
  title: _propTypes["default"].string,
  icon: _propTypes["default"].string,
  content: _propTypes["default"].string,
  btnLeft: _propTypes["default"].string,
  btnRigth: _propTypes["default"].object,
  date: _propTypes["default"].string,
  check: _propTypes["default"].bool,
  iconActive: _propTypes["default"].bool,
  iconLabel: _propTypes["default"].string
};
var _default = Cards;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/Cards/Cards.js
// module id = 1892
// module chunks = 0